<app-file-upload
	*ngIf="type !== 'modal'"
	class="w-full"
	[type]="type"
	(fileSelected)="_fileSelected($event)"
	(success)="_success($event)"
	(failed)="_failed($event)"
	[docId]="docId"
	[label]="label"
	[documentType]="documentType"
></app-file-upload>
<div *ngIf="type === 'modal'" class="w-full">
	<div class="flex justify-between items-center">
		<div>
			<h4>{{ label }}</h4>
			<p class="text-grey text-md">File type: {{ fileDescriptions }}</p>
		</div>
		<app-button
			[icon]="ICON.ARROW_UP_FROM_BRACKET"
			(onClick)="upload()"
			[testHook]="testHooks.UploadButton"
			>Upload</app-button
		>
	</div>
	<div class="flex flex-col items-center justify-center gap-3 mt-2">
		<div class="w-24">
			<img
				src="/assets/images/empty-states/document.svg"
				alt="No documents uploaded"
			/>
		</div>
		<h4>No documents uploaded</h4>
	</div>
</div>
